import axios from 'axios';
import en from '@/locales/en.js'
if (!import.meta.env.VITE_APP_CONTENT_API_URL || !import.meta.env.VITE_APP_CONTENT_API_URL) {
  throw new Error('ABMI API Env not set: VITE_APP_CONTENT_API_URL, VUE_APP_ABMI_API_KEY');
}

const abmiApiUrl = import.meta.env.VITE_APP_CONTENT_API_URL;

const abmiAxios = axios.create({
  baseURL: abmiApiUrl
});
export async function loadLanguage () {
  const apiFct = '/.rest/website-lang/?@ancestor=/biobrowser&limit=100000';
  try {
    const response = await abmiAxios.get(apiFct);
    const data = response.data.results;
    const obj = {};
    data.forEach(p => {
      p['@path'].substring(1).split('/').reduce((o, name, currentIndex, arr) => {
        o[name] = o[name] || {};
        if (currentIndex === (arr.length - 1)) {
          o[name] = p.description ?? p.descriptionHTML;
        }
        return o[name];
      }, obj);
    });

    return obj;
  } catch (error) {
    console.error(error);
    return en;
  }
}
